import Pickleball from './Pickleball.png'
import cricket from './cricket.png'
import football from './football.png'
import tabletennis from './table-tennis.png'

import Volleyball from './Volleyball.png'
import badminton from './badminton.png'
import basketball from './basketball.png'
import boxing from './boxing.png'
import swimming from './swimming.png'
import infoIcon from './infoIcon.png'





const Icons = {
    infoIcon,
    Volleyball,
    badminton,
    basketball,
    Pickleball,
    boxing,
    swimming,
    cricket,
    football,
    tabletennis

}

export default Icons;